import React from 'react'
import { useAccess } from '../../Hooks/Features/HelpDesk/useAccess';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { Dialog } from 'primereact/dialog';


const ProjectAccess = ({ projectOpts, setShowRequestPopup, callApi, editData, dropdownOption, setEditData }) => {
    const { ProjectAccessRequestUpsert, handleChange, projectAccessRequestData, setProjectAccessRequestData, options, loader, showPopup, setShowPopup, handleRadioChange, mismatchedUsers, confirmation, setConfirmation, handleSelection, upsertStatusOfBillable } = useAccess({ projectOpts, setShowRequestPopup, callApi, editData, dropdownOption });

    return (
        <div className='my-2'>
            <div className="d-flex gap-4 align-items-center">
                {
                    dropdownOption?.action?.map((values, index) => {
                        return (
                            <div>
                                <input
                                    type="radio"
                                    id="existing"
                                    name="request_type_id"
                                    key={index}
                                    value={values?.request_type_key}
                                    onChange={(e) => handleChange(e, true)}
                                    checked={projectAccessRequestData?.request_type_id === values?.request_type_key}
                                    style={{ marginLeft: 0 }}
                                />
                                <label htmlFor="existing">{values?.request_type_name}</label>
                            </div>
                        )
                    })
                }

            </div>

            <div className='row'>
                <div className='col-md-6'>
                    <div className="mt-2">Project Name</div>
                    <Dropdown className="input-dd" options={projectOpts} optionLabel="project_name" value={projectAccessRequestData?.project_id} onChange={handleChange} placeholder="Project" filter filterInputAutoFocus name="project_id" />
                </div>
            </div>
            {
                projectAccessRequestData?.show && <div className='d-flex gap-2 justify-content-between'>
                    <div className="w35">
                        <label for="assigned-to" className="mt-2"> Assigned To</label>
                        <MultiSelect
                            placeholder="Assigned To"
                            name='assignedTo'
                            options={dropdownOption.assignedTo || []}
                            value={projectAccessRequestData.assignedTo}
                            optionLabel="user_display_name"
                            onChange={handleChange}
                            className='input-dd'
                            filter filterInputAutoFocus style={{ width: "100%" }}
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'assignedTo', projectAccessRequestData.assignedTo, (val) => setProjectAccessRequestData((prev) => ({ ...prev, assignedTo: val })), () => { })} />

                    </div>
                    <div className="w35">
                        <label for="project-role" className="mt-2">Project Role</label>
                        <Dropdown showClear placeholder="Project Role" name="projectRole" options={dropdownOption.projectRole || []} value={projectAccessRequestData?.projectRole} optionLabel="project_role_name" className="input-dd"
                            onChange={handleChange}
                            filter filterInputAutoFocus />
                    </div>
                    <div className="align-self-end mb-2">
                        <div className="d-flex align-items-center gap-3">
                            <label for="choose-action" className=" fw-bold">Is Billable:</label>
                            <input type="checkbox" name='is_billable' checked={projectAccessRequestData?.is_billable} value={projectAccessRequestData?.is_billable} onChange={(e) => handleRadioChange(e.value?.checked)} disabled={!dropdownOption?.userInfo?.is_admin_default} />
                        </div>
                    </div>
                    {/* <div className="align-self-end mb-2">
                        <div className="d-flex align-items-center ">
                            <div>
                                <input
                                    type="radio"
                                    id="billable"
                                    name="is_billable"
                                    value="true"
                                    checked={projectAccessRequestData?.is_billable === true}
                                    onChange={() => handleRadioChange(true)}
                                />
                                <label htmlFor="billable" className="ms-1">Billable</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="nonbillable"
                                    name="is_billable"
                                    value="false"
                                    checked={projectAccessRequestData?.is_billable === false}
                                    onChange={() => handleRadioChange(false)}
                                />
                                <label htmlFor="nonbillable" className="ms-1">Non-Billable</label>
                            </div>
                        </div>
                    </div> */}


                </div>
            }
            <div className='row'>
                {
                    projectAccessRequestData?.show && <div className="col-6 inspectra-calendar">
                        <label for="end-date" className="mt-2">Expiry Date</label>
                        <Calendar value={projectAccessRequestData.endDate} name="endDate" onChange={handleChange} minDate={new Date(new Date().setDate(new Date().getDate() + 7))}
                            maxDate={
                                projectAccessRequestData?.projectRole?.exp_days > 0
                                    ? new Date(new Date().setDate(
                                        new Date().getDate() + projectAccessRequestData.projectRole.exp_days
                                    ))
                                    : new Date(new Date().setDate(
                                        new Date().getDate() + 15
                                    ))
                            }
                            dateFormat='dd-mm-yy'
                            className='border mt-1 input-dd'
                            placeholder='Expiry Date'
                        />
                    </div>
                }

                {
                    !projectAccessRequestData?.show && <div className="col-4">
                        <label for="assigned-to" className="mt-2"> Revoked To</label>
                        <Dropdown showClear placeholder="Revoked To" name='assignedTo' options={options?.userList || []} value={projectAccessRequestData?.assignedTo} optionLabel="user_display_name" className="input-dd"
                            onChange={handleChange}
                            filter filterInputAutoFocus />
                    </div>
                }

                {
                    !projectAccessRequestData?.show > 0 &&
                    <div className='col-md-4'>
                        <label for="assigned-to" className="mt-2"> Project Role</label>
                        <MultiSelect showClear
                            placeholder="Project Role"
                            name='projectRole'
                            options={options?.projectRole || []}
                            value={projectAccessRequestData?.projectRole}
                            optionLabel="project_role_name"
                            onChange={handleChange}
                            filter filterInputAutoFocus className='w100'
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'projectRole', projectAccessRequestData.projectRole, (val) => setProjectAccessRequestData((prev) => ({ ...prev, projectRole: val })), () => { })} />
                    </div>
                }

                <div className={!projectAccessRequestData?.show ? "col-4" : "col-6"}>
                    <label for="request-to" className="mt-2">Request To</label>
                    <Dropdown showClear placeholder="Request To" name='requestTo' options={options?.leadList || []} value={projectAccessRequestData?.requestTo} optionLabel="project_lead_user_name" className="input-dd"
                        onChange={handleChange}
                        filter filterInputAutoFocus />
                </div>
                {projectAccessRequestData?.is_billable && projectAccessRequestData.request_type_id === "helpdesk_grant_tab" &&
                    <div className="col-12 mb-1 text-danger">
                        Note:The person for whom you are requesting is being added as billable.
                    </div>
                }
                <div className="d-flex justify-content-end align-items-center mt-3">
                    <button className="btn btn-secondary" onClick={() => { setShowRequestPopup(false); setEditData({}) }}>Cancel</button>
                    {
                        loader ? <button className="btn btn-secondary" style={{ width: "60px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className="btn btn-primary" onClick={ProjectAccessRequestUpsert}>Submit</button>
                    }
                </div>
            </div>
            <Dialog visible={showPopup} onHide={() => { setShowPopup(false); setConfirmation({}); handleSelection(); }} draggable={false} className='modal-xsmall' >
                <p>
                    {`These users (${mismatchedUsers.map(u => u.user_display_name).join(", ")}) are  ${projectAccessRequestData?.is_billable ? " Non-Billable" : "Billable"}. Would you like to update them?`}
                </p>

                {
                    confirmation?.is_update && <input
                        type="text"
                        value={confirmation?.remark}
                        placeholder="Enter remark"
                        className='input-text m-0 w100'
                        onChange={(e) => { setConfirmation((prev) => ({ ...prev, remark: e.target.value })) }}
                    />
                }
                <div className="d-flex gap-2 justify-content-center align-items-center py-2 ">
                    {
                        confirmation?.is_update ?
                            <button className='btn btn-primary' onClick={upsertStatusOfBillable}>Submit</button> :
                            <>
                                <button className='btn btn-secondary' onClick={() => { setConfirmation((prev) => ({ ...prev, is_update: true })) }}>Yes</button>
                                <button className='btn btn-primary' onClick={() => {
                                    handleSelection();
                                    setShowPopup(false);
                                    setConfirmation({ is_update: false, remark: '' });
                                }}>No</button>
                            </>
                    }
                </div>
            </Dialog >
        </div >
    )
}

export default ProjectAccess